import { Produkt } from "../types/organizacje";
import { SettingsAction, settingsConst } from "../types/settings";

export interface SettingsState {
  dostepneProdukty: Produkt[];
}

const initialState: SettingsState = {
  dostepneProdukty: [],
};

export default function settings(
  state = initialState,
  action: SettingsAction
): SettingsState {
  switch (action.type) {
    case settingsConst.DAJ_DOSTEPNE_PRODUKTY_SUCCESS:
      return {
        ...state,
        dostepneProdukty: action.produkty,
      };
    default:
      return state;
  }
}
